import React, { Component, Fragment } from 'react';
import 'CSS/demand-supply/demand-supply.scss';
import 'CSS/dashboard-statistic.scss';
import 'CSS/dashboard-tickets.scss';
import 'CSS/dashboard-slips.scss';
import Grid from '@material-ui/core/Grid';
import { API_ROOT } from 'Api/Routes';
import PreviewImageModal from 'PreviewImageModal';

class Photos extends Component {
  state = {
    preview: false,
    activeAsset: null,
  };

  openPreview = asset => {
    this.setState({
      preview: true,
      activeAsset: asset,
    });
  };

  closePreview = () => {
    this.setState({
      preview: false,
      activeAsset: null,
    });
  };

  render() {
    const { assets = [] } = this.props;

    return (
      <Grid item md={12} lg={6} className="">
        <Grid container className="u-pad-bot-10 ">
          <Grid item md={12} lg={6} className="">
            <h2 className="t-primary-16 t-weight-b u-mrg-bot-10 u-mrg-top-0">
              Photos
            </h2>
          </Grid>
          {assets && assets.length ? (
            <Fragment>
              <div className="demand-slip__photos">
                {assets.map((asset, i) => (
                  <img
                    key={i}
                    alt="Demand slip"
                    className="demand-slip__photo"
                    src={`${API_ROOT}/asset/${asset}`}
                    onClick={() => this.openPreview(asset)}
                  />
                ))}
              </div>
              <PreviewImageModal
                open={this.state.preview}
                onClose={this.closePreview}
                image={this.state.activeAsset}
              />
            </Fragment>
          ) : null}
        </Grid>
      </Grid>
    );
  }
}

Photos.defaultProps = {
  assets: [],
};

export default Photos;
